import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'characteristics',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './characteristics.component.html',
  styleUrl: './characteristics.component.css'
})
export class CharacteristicsComponent implements OnInit, OnChanges {

  @Input() parentInterviewData: any;
  @Output() onSaveSection10 = new EventEmitter<any>();

  yesNo = EYesNo;
  characteristicForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "What has your child's mood been like recently? *",
      formControlName: "child_mood",
    },
    {
      question: "How would you describe your child's sleep habits? *",
      formControlName: "child_sleep_habits",
    },
    {
      question: "How would you describe your child's appetite? *",
      formControlName: "child_appetite",
    },
    {
      question: "How would you describe your child's energy level? *",
      formControlName: "child_energy_level",
    },
    {
      question: "How would you describe your child's concentration? *",
      formControlName: "child_concentration",
    },
  ]

  radioQuestions = [
    {
      id: 'follow_directions',
      questionText: 'Does he/she follow directions without repetition and reminders? *',
      formControlName: 'follow_directions',
      infoFormControlName: 'follow_directions_information'
    },
    {
      id: 'say_without_thinking',
      questionText: 'Does your child say things without thinking? *',
      formControlName: 'say_without_thinking',
      infoFormControlName: 'say_without_thinking_information'
    },
    {
      id: 'surprise_consequences',
      questionText: 'Is your child surprised by consequences when he/she is held accountable? *',
      formControlName: 'surprise_consequences',
      infoFormControlName: 'surprise_consequences_information'
    },
    {
      id: 'child_anxiety',
      questionText: 'Has your child been unusually nervous or anxious recently? *',
      formControlName: 'child_anxiety',
      infoFormControlName: 'child_anxiety_information'
    },
    {
      id: 'child_short_temper',
      questionText: 'Has your child been irritable or short-tempered recently? *',
      formControlName: 'child_short_temper',
      infoFormControlName: 'child_short_temper_information'
    },
    {
      id: 'hurt_child',
      questionText: 'Has your child ever talked about suicide or otherwise hurting himself/herself? *',
      formControlName: 'hurt_child',
      infoFormControlName: 'hurt_child_information'
    },
    {
      id: 'not_real',
      questionText: "Has your child ever said things that didn't make sense or seemed to believe in things that weren't real? *",
      formControlName: 'not_real',
      infoFormControlName: 'not_real_information'
    },
    {
      id: 'counselor',
      questionText: 'Has your child ever seen a counselor or therapist? *',
      formControlName: 'counselor',
      infoFormControlName: 'counselor_information'
    },
    {
      id: 'agencies',
      questionText: 'Has your child had any involvement with other agencies or programs in the community? *',
      formControlName: 'agencies',
      infoFormControlName: 'agencies_information'
    },
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.parentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.characteristicForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.characteristicForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.characteristicForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveCharacteristic(): void {
    if (this.characteristicForm.valid) {
      this.onSaveSection10.emit(this.characteristicForm.value);
    }
  }

}
